"use client";

import React from "react";
import { motion, useScroll } from "framer-motion";

const ANIMATIONS = {
  fadeIn: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
  },
  fadeInUp: {
    initial: { opacity: 0, y: 50 },
    animate: { opacity: 1, y: 0 },
  },
  fadeInDown: {
    initial: { opacity: 0, y: -50 },
    animate: { opacity: 1, y: 0 },
  },
};

const Animate = ({
  children,
  animation = "fadeIn",
  duration = 1,
  delay = 0.5,
  threshold = 0.4,
  className = "",
}) => {
  const animConfig = ANIMATIONS[animation] || ANIMATIONS.fadeIn;

  const { scrollYprogress } = useScroll();

  return (
    <motion.div
      className={`h-full w-full overflow-hidden ${className}`}
      initial="initial"
      whileInView="animate"
      viewport={{ once: true, amount: threshold }}
      variants={animConfig}
      transition={{ duration: Math.abs(duration), delay, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
};

export default Animate;
